const LangContactUs = {
	"contact._title": ["CONTACT US", "LIÊN HỆ CHÚNG TÔI"],

	"contact.subTitle._howCanWeHelp": [
		"Need some help on your Starbucks Rewards™ account?",
		"Bạn cần trợ giúp cho tài khoản Starbucks Rewards™?",
	],

	"contact.form._description": [
		"<p>We welcome all questions, comments and feedback - it helps us make your experience at Starbucks the best it can be.</p><p>Please select the topic below that best fits your comment or question, then e-mail us.</p>",
		"<p>Chúng tôi rất mong nhận được góp ý hcủa bạn để giúp chúng tôi mang đến trải nghiệm tốt nhất cho bạn.</p><p>Hãy chọn chủ đề hoặc câu bạn bạn muốn gửi đến chúng tôi.</p>",
	],

	"contact.form.label._privacyAgreement": [
		"Confirm that I am aware the personal data I submit to Starbucks will be used in accordance with the Starbucks Privacy Statement",
		"Đồng ý rằng các thông tin cá nhân của tôi sẽ được Starbucks sử dụng vá tuân thủ các chính sách bảo mật của công ty.",
	],
	"contact.form.name._privacyAgreement": [
		"Privacy Agreement",
		"Chính sách bảo mật thông tin",
	],
	"contact.form._privacyAgreementRules": ["", ""],
}

export default LangContactUs
